var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkOrangeExclamationHollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3986 4.8986C6.34317 2.95406 9.0317 1.75 12 1.75C14.9683 1.75 17.6568 2.95406 19.6014 4.8986C21.5459 6.84317 22.75 9.5317 22.75 12.5C22.75 15.4683 21.5459 18.1568 19.6014 20.1014C17.6568 22.0459 14.9683 23.25 12 23.25C9.0317 23.25 6.34317 22.0459 4.3986 20.1014C2.45406 18.1568 1.25 15.4683 1.25 12.5C1.25 9.5317 2.45407 6.84316 4.3986 4.8986ZM12 3.25C9.4455 3.25 7.13403 4.28452 5.45926 5.95926C3.78451 7.63404 2.75 9.9455 2.75 12.5C2.75 15.0545 3.78452 17.366 5.45926 19.0407C7.13403 20.7155 9.4455 21.75 12 21.75C14.5545 21.75 16.866 20.7155 18.5407 19.0407C20.2155 17.366 21.25 15.0545 21.25 12.5C21.25 9.9455 20.2155 7.63403 18.5407 5.95926C16.866 4.28452 14.5545 3.25 12 3.25Z",
    fill: "#EE7200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19C12.6903 19 13.25 18.4403 13.25 17.75C13.25 17.0597 12.6903 16.5 12 16.5C11.3097 16.5 10.75 17.0597 10.75 17.75C10.75 18.4403 11.3097 19 12 19Z",
    fill: "#EE7200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75C12.4142 5.75 12.75 6.08579 12.75 6.5V14.5C12.75 14.9142 12.4142 15.25 12 15.25C11.5858 15.25 11.25 14.9142 11.25 14.5V6.5C11.25 6.08579 11.5858 5.75 12 5.75Z",
    fill: "#EE7200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkOrangeExclamationHollow);
export default __webpack_public_path__ + "static/media/dark-orange-exclamation-hollow.5f78e7da.svg";
export { ForwardRef as ReactComponent };